import React from 'react'
import moment from 'moment'
import BodyText from 'components/Luxkit/Typography/BodyText'
import HelpPane from 'components/Common/HelpPane'
import Modal from 'components/Luxkit/Modal/Modal'
import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'

interface Props {
  experience: App.ExperienceOffer
  onSupportEmailClick?: () => void
  onSupportNumberClick?: () => void
}

function ExperienceGiveAsGiftInfoModal(props: Props) {
  const { experience, onSupportEmailClick, onSupportNumberClick } = props

  return (<Modal title="Gifting available">
    <BodyText className="full-width" variant="large">
      {`Buy a package and send as a gift to a special someone.
          They can book by ${moment(experience.bookByDate ?? experience.expirationDate).format(DMY_CASUAL_FORMAT)} and travel until ${moment(experience.expirationDate).format(DMY_CASUAL_FORMAT)}.`}
    </BodyText>
    <HelpPane
      onSupportEmailClick={onSupportEmailClick}
      onSupportNumberClick={onSupportNumberClick}/>
  </Modal>)
}

export default ExperienceGiveAsGiftInfoModal
